<mat-icon style="cursor: pointer" class="position-absolute end-0 top-0" (click)="close()">cancel</mat-icon>
<mat-nav-list>
  <h1>{{this.data.title}}</h1>
  <h2>{{this.data.description}}</h2>
  <ul>
    <li style="list-style: disc" *ngFor="let item of this.data.items">{{item}}</li>
  </ul>
</mat-nav-list>
